import 'babel-polyfill'
import Vue from 'vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from './store'
//import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import i18n from './locale/i18n'
//import VueGtag from "vue-gtag";
import 'leaflet/dist/leaflet.css';

Vue.config.productionTip = false

Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
Vue.use(VueAxios, axios)

if(process.env.NODE_ENV === 'production'){
  //https://matteo-gabriele.gitbook.io/vue-gtag/
  /*
  Vue.use(VueGtag, {
    config: { id: "UA-169012180-2" }
  });
  */
}

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
